import React from 'react';
import './Ticket.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';



const Ticket = ({ title, price, features }) => {

  return (
    <div className="ticket-item">

      <div className="ticket-header">

        <div className="intro">
          <h3>{title}</h3> {/* Ticket Title */}
          <div className="price">${price}</div> {/* Ticket Price */}
        </div>

        {/* List of Features */}
        <ul>
          {features.map((feature, index) => (
            <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
          ))}
        </ul>

      </div>

      {/* Cut Line as a Separator */}
      <div className="cut"><div className="dash"></div></div> {/* Separator */}

      {/* Ticket Footer with Register Button */}
      <div className="ticket-footer">
        <Button link={"Registration"} title={"Register Now"} />
      </div>

    </div>
  );
};

export default Ticket;